import { AbstractControl, Validators } from '@angular/forms';

const validatorFn = Validators.pattern(/^\S*$/);

export function ValidateNoWhitespace(control: AbstractControl) {
  const err = validatorFn(control);
  return err ? { whitespace: true } : null;
}
